import { LocaleInfo } from "./types";

export const SUPPORTED_LANGUAGES = ["en"];
export const DEFAULT_LOCALE = "en";
export const locales: { [key: string]: LocaleInfo } = {
  en: {
    locale: "en",
    longName: "English",
    shortName: "En",
    isRtl: false,
    lcid: 9,
  },
};

export const DEFAULT_LCID = 0;
